import React from "react";
import TableLoader from "../../../../loader/TableLoader";
import {
  convertTo12HourFormat,
  NoItemsLeftInTable,
} from "../../../../../helpers/helpers";
import { useMediaQuery } from "react-responsive";

function OfferTables({ OfferList, loadings }) {
  const isTablet = useMediaQuery({ query: "(max-width: 990px)" });

  if (loadings) {
    return (
      <div className="valign-wrapper justify-center cover white mt-1">
        <TableLoader
          headerData={[
            "Scrap type",
            "Offer time",
            "Qunatity/UOM",
            "EMD amounts(Rs)",
          ]}
        />
      </div>
    );
  }

  return (
    <div className={`mt-1 ${!isTablet && "table-container-style"}`}>
      <table
        className={`responsive-table centered ${
          isTablet ? "auction_table table-style" : "custom-table-style"
        } `}
      >
        <thead>
          <tr>
            <th>S.No</th>
            <th>Scrap type</th>
            <th>Offer time</th>
            <th>Qunatity/UOM</th>
            <th>EMD amounts(Rs)</th>
          </tr>
        </thead>

        <tbody>
          {OfferList?.map((item, index) => (
            <tr key={item?._id}>
              <td>{index + 1}</td>
              <td>{item?.scrapDetails?.type}</td>
              <td>
                {convertTo12HourFormat(item?.offerSchedule?.startTimeAndDate)}
              </td>
              <td>{`${item?.scrapDetails?.quantity}/${item?.scrapDetails?.unit}`}</td>
              <td>{item?.EMDAmount}</td>
            </tr>
          ))}
        </tbody>
      </table>
      {OfferList?.length === 0 && <NoItemsLeftInTable />}
    </div>
  );
}

export default OfferTables;
